module.exports = __webpack_public_path__ + "assets/img/healthcareSolutions-education.ca2af985.png";